import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

interface Props {
  children: JSX.Element;
}

export const IsDesktop = ({ children }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const isDesktop = useMediaQuery({ minWidth: 992 });
  return mounted && isDesktop ? children : null;
};
export const IsTablet = ({ children }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  return mounted && isTablet ? children : null;
};
export const IsMobile = ({ children }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return mounted && isMobile ? children : null;
};
// Not mobile (desktop or laptop or tablet)
export const IsDefault = ({ children }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const isNotMobile = useMediaQuery({ minWidth: 768 });
  return mounted && isNotMobile ? children : null;
};
